import React from "react";
import styles from "./toastdialpad.module.scss";
type DiallpadToastProps = {
  showMsg: string;
};

export default function DiallpadToast({showMsg}:DiallpadToastProps) {

  return (
    <>
      <div className={styles.calldialpadtoast}>
        <div className={styles.toast}>
          <span className="icon_info"></span>
          <p>{ showMsg }</p>
          <span className={`icon_close ${styles.close}`}></span>
        </div>
      </div>
    </>
  );
};